module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_null@3x.ca0f23e3.png";